import { IconButton } from "@mui/material";
import { NavigateNext, ExpandMore } from "@mui/icons-material";

type Props = {
  isVisible: boolean;
  isOpen: boolean;
  onToggle: () => void;
};

const ExpandFolderButton = ({ isVisible, isOpen, onToggle }: Props) => {
  return (
    <IconButton
      sx={{ visibility: isVisible ? "visible" : "hidden", mr: 1 }}
      onClick={onToggle}
    >
      {isOpen ? <ExpandMore /> : <NavigateNext />}
    </IconButton>
  );
};

export default ExpandFolderButton;
